import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Suscription from './pages/Suscription';
import Hub from './pages/Hub';
import ArticlePage from './pages/ArticlePage';
import AuthWatcher from './components/AuthWatcher';
import UserProfilePage from './pages/UserProfilePage';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthWatcher />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hub" element={<Hub />} />
          <Route path="/article/:id" element={<ArticlePage />} />
          <Route path="/suscription/*" element={<Suscription />} />
          {/* Clerk UserProfile - mounted at /user-profile/* */}
          <Route path="/user-profile/*" element={<UserProfilePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;